var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amap-container"},[_c('div',{ref:"mapContainer",staticStyle:{"width":"100%","height":"100vh"},attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }